import React from "react";

import PropTypes from "prop-types";

import Navbar from "react-bootstrap/Navbar";

import logo from "../../assets/svg/logo.svg";

import iconsRegHubLogo from "../../assets/svg/icons-regHubLogo.svg";

import iconsSearch from "../../assets/svg/icons-search.svg";

import iconsChangePassword from "../../assets/svg/icons-changePassword.svg";

import iconsLogOut from "../../assets/svg/icons-log-out.svg";

import iconsDeleteAccount from "../../assets/svg/icons-deleteAccount.svg";

import iconsHamgurger from "../../assets/svg/icons-hamburger.svg";

import Form from "react-bootstrap/Form";

import FormControl from "react-bootstrap/FormControl";

import InputGroup from "react-bootstrap/InputGroup";

import Button from "react-bootstrap/Button";

import { connect } from "react-redux";

import { bindActionCreators } from "redux";

import { changeUserTokenAndCurrentWorkspace } from "../../actions/configActions";

import {
  loggedOut,
  deleteUser,
  changePassword,
  requestWorkspace,
} from "../../actions/userActions";

import { restartTopicMessages } from "../../actions/topicActions";

import { getInitialUserToken } from "../../actions/configActions";

import { checkUserRights } from "../../actions/userActions";

import { getFilterTypes } from "../../actions/filterActions";

import { useTranslation } from "react-i18next";

import { useLocation, Link, useHistory } from "react-router-dom";

import {
  REGISTER,
  LOG_IN,
  TITLE_BESIDE_LOGO,
  HOME,
  WORKSPACE_TYPE_PRIVATE,
  WORKSPACE_IMAGE_PATH_ON_ERROR,
  SEARCH_BY_TEXT_AWAITING_TEXT,
} from "../../constants/stringConstants";

import Dropdown from "react-bootstrap/Dropdown";

import Container from "react-bootstrap/Container";

import { useState, useEffect } from "react";

import useWindowDimensions from "../../utils/useWindowDimensions";

import CustomModal from "../../utils/CustomModal";
import {
  NEW_PASSWORD,
  REPEATED_NEW_PASSWORD,
} from "../../constants/stringConstants";

import FieldsInForm from "../../utils/FieldsInForm";

import AlertMessage from "../../utils/AlertMessage";

import { isIPad13, isMacOs, isSafari } from "react-device-detect";

import iconsCheckmark from "../../assets/svg/icons-checkmark.svg";

import iconsPublications from "../../assets/svg/icons-publications.svg";

import iconsManage from "../../assets/svg/icons-manage.svg";

import iconsAddToList from "../../assets/svg/icons-addToList.svg";

import iconsEdit from "../../assets/svg/icons-edit.svg";

import iconsDelete from "../../assets/svg/icons-delete.svg";

import iconsBack from "../../assets/svg/icons-back.svg";

import {
  crawlerSourcesAreLoadedWithErrorAction,
  crawlerSourcesSuccessMessageFired,
  getCrawlerSources,
  deleteCrawlerSource,
  previewCrawlerSources,
  addCrawlerSources,
  updateCrawlerSources,
} from "../../actions/sourcesActions";

import Loader from "../../utils/Loader";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { AgGridColumn } from "ag-grid-react/lib/agGridColumn";
import { Row, Col } from "react-bootstrap";
import { addArrayAction } from "../../actions/newsListActions";

const Header = ({
  loggedIn,
  user,
  workspacesOfUser,
  loggedOut,
  getInitialUserToken,
  dispatch,
  changeUserTokenAndCurrentWorkspace,
  restartTopicMessages,
  checkUserRights,
  userRegistrationIsLoading,
  userLoggingIsLoading,
  sourcesSuccessMessage,
  sourcesAreLoadedWithErrorMessage,
  crawlerSourcesAreLoadedWithErrorAction,
  crawlerSourcesSuccessMessageFired,
  userRights,
  getCrawlerSources,
  userToken,
  sourcesAreLoading,
  sources,
  deleteCrawlerSource,
  filtersTypes,
  getFilterTypes,
  previewCrawlerSources,
  previewedCrawlerSource,
  addCrawlerSources,
  updateCrawlerSources,
}) => {
  let localStoragePersist = JSON.parse(
    window?.localStorage?.getItem("persist:configPersist")
  );
  let localStorageCurrentWorkspace = JSON.parse(
    localStoragePersist?.currentWorkspace
  );
  const { t } = useTranslation(),
    location = useLocation(),
    history = useHistory(),
    [isDeleteSourceDialogOpened, setIsDeleteSourceDialogOpened] = useState(
      false
    ),
    [currentWorkspace, setCurrentWorkspace] = useState(
      localStorageCurrentWorkspace
    ),
    [isDeletedDialogOpened, setIsDeletedDialogOpened] = useState(false),
    [
      isCreateATeamWorkspaceDialogOpened,
      setIsCreatedATeamWorkspaceDialogOpened,
    ] = useState(false),
    { width } = useWindowDimensions(),
    [isChangePasswordDialogOpened, setIsChangePasswordDialogOpened] = useState(
      false
    ),
    [isAddPublicationSourceOpened, setIsAddPublicationSourceOpened] = useState(
      false
    ),
    [freeText, setFreeText] = useState(""),
    [countriesDataSet, setCountriesDataSet] = useState([]),
    [
      isEditPublicationSourceOpened,
      setIsEditPublicationSourceOpened,
    ] = useState(false),
    [selectedSourceRecord, setSelectedSourceRecord] = useState({}),
    [publisherTypesDataSet, setPublisherTypesDataSet] = useState([]),
    [currentSourceObject, setCurrentSourceObject] = useState({}),
    [submitSourceOccurred, setSubmitSourceOccurred] = useState(false),
    argsForFields = {
      findFormErrors: (form) => {
        const { NEW_PASSWORD, REPEATED_NEW_PASSWORD } = form;
        const newErrors = {};

        if (!NEW_PASSWORD || NEW_PASSWORD === "")
          newErrors.NEW_PASSWORD = t("newPasswordIsMandatoryField");
        else if (NEW_PASSWORD.length > 255)
          newErrors.NEW_PASSWORD = t(
            "newPasswordCantBeLongerThan255Charachteres"
          );
        else if (NEW_PASSWORD.length < 6)
          newErrors.NEW_PASSWORD = t(
            "newPasswordCantBeLongerThan6Charachteres"
          );

        if (!REPEATED_NEW_PASSWORD || REPEATED_NEW_PASSWORD === "")
          newErrors.REPEATED_NEW_PASSWORD = t(
            "repeatedNewPasswordIsAMandatoryField"
          );
        else if (REPEATED_NEW_PASSWORD.length > 255)
          newErrors.REPEATED_NEW_PASSWORD = t(
            "repeatedNewPasswordCantBeLongerThan255Charachteres"
          );
        else if (REPEATED_NEW_PASSWORD.length < 6)
          newErrors.REPEATED_NEW_PASSWORD = t(
            "repeatedNewPasswordCantBeShorterThan6Charachteres"
          );
        else if (REPEATED_NEW_PASSWORD !== NEW_PASSWORD)
          newErrors.REPEATED_NEW_PASSWORD = t(
            "repeatedNewPasswordMustBeTheSameAsTheNewPassword"
          );

        return newErrors;
      },
      fields: [
        {
          name: NEW_PASSWORD,
          type: "password",
          className: "register-login-text-field",
          required: true,
          classnameofgroup: "register-login-text-field-group",
          label: t("newPassword"),
          placeholder: t("enterANewPassword"),
        },
        {
          name: REPEATED_NEW_PASSWORD,
          type: "password",
          className: "register-login-text-field",
          required: true,
          classnameofgroup: "register-login-text-field-group",
          label: t("repeatNewPassword"),
          placeholder: t("repeatTheNewPassword"),
        },
      ],
      onSubmit: (values) => {
        // changePassword(currentWorkspace.USER_TOKEN, values.NEW_PASSWORD);
        changePassword(
          localStorageCurrentWorkspace.USER_TOKEN,
          values.NEW_PASSWORD
        );
        setIsChangedPassword(true);
        setIsChangePasswordDialogOpened(false);
      },
      classNameReactFormal: "register-login-react-formal",
      classNameForm: "register-login-react-form",
    },
    argsForAddEditPublicationSourceDialog = {
      findFormErrors: (form) => {
        const { NAME, URL, COUNTRY, PUBLISHER_TYPE, SEARCH_CRITERIA } = form,
          newErrors = {};

        if (!NAME || NAME === "")
          newErrors.NAME = t("sourceNameIsMandatoryField");
        else if (NAME.length > 128)
          newErrors.NAME = t("nameCantBeLongerThen128Letters");

        if (!URL || URL === "") newErrors.URL = t("sourceURLIsMandatoryField");
        else if (URL.length > 512)
          newErrors.URL = t("URLcan'tbelongerthen512letters");

        if (!COUNTRY || COUNTRY === "")
          newErrors.COUNTRY = t("sourceCountryIsMandatoryField");

        if (!PUBLISHER_TYPE || PUBLISHER_TYPE === "")
          newErrors.PUBLISHER_TYPE = t("sourcePublisherTypeIsMandatoryField");

        if (!SEARCH_CRITERIA || SEARCH_CRITERIA === "")
          newErrors.SEARCH_CRITERIA = t("sourceSearchCriteriaIsMandatoryField");
        else if (SEARCH_CRITERIA.length > 1024)
          newErrors.SEARCH_CRITERIA = t(
            "searchCriteriaCantBeLongerThen1024Letters"
          );

        return newErrors;
      },
      fields: [
        {
          name: "NAME",
          type: "text",
          label: t("name"),
          placeholder: t("theNameOfTheSource"),
          sideLabel: t("eachSourceHasUniqueName"),
          required: true,
        },
        {
          name: "URL",
          type: "text",
          label: t("url"),
          placeholder: t("egNewYorkFedURL"),
          sideLabel: t("theURLIsTheRootSourceOfPublication"),
          required: true,
        },
        {
          name: "COUNTRY",
          type: "select",
          className: "register-login-text-field overview-fieldset-field",
          disabled: false,
          classnameofgroup:
            "register-login-text-field-group overview-fieldset-group",
          options: countriesDataSet,
          displayProperty: "description",
          valueProperty: "value",
          label: t("country"),
          placeholder: t("egUnitedKingdom"),
          sideLabel: t("theCountryOfPublicationSource"),
          required: true,
        },
        {
          name: "PUBLISHER_TYPE",
          type: "select",
          className: "register-login-text-field overview-fieldset-field",
          disabled: false,
          classnameofgroup:
            "register-login-text-field-group overview-fieldset-group",
          options: publisherTypesDataSet,
          displayProperty: "description",
          valueProperty: "value",
          label: t("publisherType"),
          placeholder: t("egConsultancy"),
          sideLabel: t("theTypeOfPublisher"),
          required: true,
        },
        {
          name: "SEARCH_CRITERIA",
          type: "textarea",
          label: t("searchCriteria"),
          placeholder: t("egPublicationsAndFinancial"),
          sideLabel: t("searchCriteriaFurtherRestrictTheSet"),
          required: true,
        },
        {
          name: "SOURCE_ID",
          type: "text",
          className: "display-none",
        },
      ],
      onSubmit: (values) => {
        previewCrawlerSources(
          userToken,
          values.NAME,
          values.URL,
          values.COUNTRY,
          values.PUBLISHER_TYPE,
          values.SEARCH_CRITERIA,
          null
        );
        setCurrentSourceObject(values);
        setPreviewForAdditionOccured(true);
      },
    },
    [submitOccurred, setSubmitOccurred] = useState(false),
    [isDeleted, setIsDeleted] = useState(false),
    [isChangedPassword, setIsChangedPassword] = useState(false),
    [isCreatedTeamWorkspace, setIsCreatedATeamWorkspace] = useState(false),
    [sourcesSuccessMessageOn, setIsSourcesSuccessMessageOn] = useState(false),
    [sourcesSuccessMessageLocal, setSourcesSuccessMessageLocal] = useState(""),
    [sourcesErrorMessageOn, setIsSourcesErrorMessageOn] = useState(false),
    [sourcesErrorMessageLocal, setSourcesErrorMessageLocal] = useState(""),
    [showManageSourcesDialog, setShowManageSourcesDialog] = useState(false),
    [previewForAdditionOccurred, setPreviewForAdditionOccured] = useState(
      false
    );

  let [selectedSourceId, setSelectedSourceId] = useState(0);
  let [filtersLoaded, setFilterLoaded] = useState(false);

  useEffect(() => {
    if (
      filtersTypes.length &&
      (!countriesDataSet.length || !publisherTypesDataSet.length)
    ) {
      if (
        Object.keys(filtersTypes[0]).length &&
        !publisherTypesDataSet.length
      ) {
        Object.keys(filtersTypes[0]).forEach((publisher_type) => {
          setPublisherTypesDataSet((publisherTypesDataSet) => [
            ...publisherTypesDataSet,
            {
              description: filtersTypes[0][publisher_type],
              value: filtersTypes[0][publisher_type],
            },
          ]);
        });
      }

      if (Object.keys(filtersTypes[2]).length && !countriesDataSet.length) {
        Object.keys(filtersTypes[2]).forEach((country) => {
          setCountriesDataSet((countriesDataSet) => [
            ...countriesDataSet,
            {
              description: filtersTypes[2][country],
              value: filtersTypes[2][country],
            },
          ]);
        });
      }
    }

    if (!filtersTypes.length && loggedIn && !filtersLoaded) {
      setFilterLoaded(true);
      getFilterTypes(userToken);
    }
  }, [
    workspacesOfUser,
    currentWorkspace,
    loggedIn,
    publisherTypesDataSet,
    setPublisherTypesDataSet,
    countriesDataSet,
    setCountriesDataSet,
    filtersTypes,
    userToken,
    filtersLoaded,
    setFilterLoaded,
    getFilterTypes,
  ]);

  function workspaceChanged(workspace) {
    restartTopicMessages();
    setCurrentWorkspace(workspace);
    dispatch(
      changeUserTokenAndCurrentWorkspace(workspace.USER_TOKEN, workspace)
    );
    dispatch(checkUserRights(workspace.USER_TOKEN));
    if (location.pathname !== HOME) history.push(HOME);
  }

  function loggOut() {
    getInitialUserToken();
    dispatch(loggedOut());

    if (location.pathname !== HOME) history.push(HOME);
  }

  function deleteUserClick() {
    deleteUser(currentWorkspace.USER_TOKEN);
    getInitialUserToken();
    dispatch(loggedOut());

    if (location.pathname !== HOME) history.push(HOME);

    setIsDeleted(true);
    setIsDeletedDialogOpened(false);
  }

  function createTeamWorkSpaceClick() {
    requestWorkspace(currentWorkspace.USER_TOKEN);
    setIsCreatedATeamWorkspace(true);
    setIsCreatedATeamWorkspaceDialogOpened(false);
  }

  function onErrorImg(me) {
    me.target.src = WORKSPACE_IMAGE_PATH_ON_ERROR;
  }

  function resetParams() {
    setCurrentWorkspace({});
    setFreeText("");
  }

  useEffect(() => {
    if (
      sourcesSuccessMessage !== sourcesSuccessMessageLocal &&
      sourcesSuccessMessage !== ""
    ) {
      setSourcesSuccessMessageLocal(sourcesSuccessMessage);
      setIsSourcesSuccessMessageOn(true);
      crawlerSourcesSuccessMessageFired("");
    }
  }, [
    setSourcesSuccessMessageLocal,
    sourcesSuccessMessageLocal,
    sourcesSuccessMessage,
    crawlerSourcesSuccessMessageFired,
    setIsSourcesSuccessMessageOn,
  ]);

  useEffect(() => {
    if (
      sourcesAreLoadedWithErrorMessage !== sourcesErrorMessageLocal &&
      sourcesAreLoadedWithErrorMessage !== ""
    ) {
      setSourcesErrorMessageLocal(sourcesAreLoadedWithErrorMessage);
      setIsSourcesErrorMessageOn(true);
      crawlerSourcesAreLoadedWithErrorAction("");
    }
  }, [
    setSourcesErrorMessageLocal,
    sourcesErrorMessageLocal,
    sourcesAreLoadedWithErrorMessage,
    crawlerSourcesAreLoadedWithErrorAction,
    setIsSourcesErrorMessageOn,
  ]);

  function openManageSourcesDialog() {
    if (
      loggedIn &&
      (currentWorkspace.WORKSPACE_TYPE !== WORKSPACE_TYPE_PRIVATE ||
        userRights.USER_RIGHT === "partner")
    ) {
      setShowManageSourcesDialog(true);
      getCrawlerSources(userToken, "active");
    }
  }

  function saveSource() {
    if (isAddPublicationSourceOpened) {
      //previewedCrawlerSource
      addCrawlerSources(
        userToken,
        currentSourceObject["NAME"],
        currentSourceObject["URL"],
        currentSourceObject["COUNTRY"],
        currentSourceObject["FORMAT"],
        currentSourceObject["PUBLISHER_TYPE"],
        currentSourceObject["SEARCH_CRITERIA"],
        "EN",
        null
      );
      setIsAddPublicationSourceOpened(false);
    }

    if (isEditPublicationSourceOpened) {
      updateCrawlerSources(
        userToken,
        currentSourceObject["NAME"],
        currentSourceObject["URL"],
        currentSourceObject["COUNTRY"],
        currentSourceObject["FORMAT"],
        currentSourceObject["PUBLISHER_TYPE"],
        currentSourceObject["SEARCH_CRITERIA"],
        "EN",
        null,
        currentSourceObject["ID"]
      );
      setIsEditPublicationSourceOpened(false);
    }

    setPreviewForAdditionOccured(false);
    setCurrentSourceObject({});
  }

  const functionsOfGrid = (event) => {
    {
      return (
        <div className="functions-of-grid">
          <img
            width={24}
            height={24}
            src={iconsEdit}
            className="cursor-pointer"
            onClick={() => {
              setSelectedSourceRecord(event.data);
              setIsEditPublicationSourceOpened(true);
            }}
          />
          <img
            width={24}
            height={24}
            src={iconsDelete}
            onClick={() => {
              setSelectedSourceId(event.data.ID);
              setIsDeleteSourceDialogOpened(true);
            }}
            className="cursor-pointer"
          />
        </div>
      );
    }
  };

  return (
    <>
      <Navbar
        variant={loggedIn ? "main-header-logged-in" : "main-header"}
        expand="lg"
      >
        <Navbar.Brand>
          {userRegistrationIsLoading || userLoggingIsLoading ? (
            <img
              src={iconsRegHubLogo}
              width="30"
              height="30"
              className="d-inline-block align-top cursor-pointer"
              alt="RegHub logo"
              onClick={() => {
                history.push(HOME);
                sessionStorage?.removeItem("savedNewsArr");
                sessionStorage?.removeItem("savedPage");
                sessionStorage?.removeItem("savedPosition");
                sessionStorage.removeItem("TOPIC_SEARCHTAGS");
                sessionStorage.removeItem("singleTopic.SUBSCRIPTION");
                sessionStorage.removeItem("SUBSCRIPTION_TYPES");
                sessionStorage.removeItem("SUBSCRIPTION_SEARCH_FILTER");
                sessionStorage.removeItem("SUBSCRIPTION_FREQUENCY");
                localStorage.removeItem("dataTiles");
                sessionStorage.removeItem("separateNewsAsk");
                dispatch(addArrayAction([]));
                sessionStorage.removeItem("tileTypes");
                sessionStorage.removeItem("separateNewsAsk");
                sessionStorage.removeItem("reference_id");
                localStorage.removeItem("singleTopicId");
                sessionStorage.removeItem("SAVED_FIELD");
                sessionStorage.removeItem("publicationTypes");
                sessionStorage.removeItem("toDate");
                sessionStorage.removeItem("fromDate");
                sessionStorage.removeItem("country");
                sessionStorage.removeItem("freeText");
                sessionStorage.removeItem("publisherTypes");
                sessionStorage.removeItem("topicsAndUnits");
              }}
            />
          ) : (
            <img
              src={iconsRegHubLogo}
              width="30"
              height="30"
              className="d-inline-block align-top cursor-pointer"
              alt="RegHub logo"
              onClick={() => {
                history.push(HOME);
                sessionStorage?.removeItem("savedNewsArr");
                sessionStorage?.removeItem("savedPage");
                sessionStorage?.removeItem("savedPosition");
                sessionStorage.removeItem("TOPIC_SEARCHTAGS");
                sessionStorage.removeItem("singleTopic.SUBSCRIPTION");
                sessionStorage.removeItem("SUBSCRIPTION_TYPES");
                sessionStorage.removeItem("SUBSCRIPTION_SEARCH_FILTER");
                sessionStorage.removeItem("SUBSCRIPTION_FREQUENCY");
                localStorage.removeItem("dataTiles");
                sessionStorage.removeItem("separateNewsAsk");
                dispatch(addArrayAction([]));
                sessionStorage.removeItem("tileTypes");
                sessionStorage.removeItem("separateNewsAsk");
                sessionStorage.removeItem("reference_id");
                localStorage.removeItem("singleTopicId");
                sessionStorage.removeItem("SAVED_FIELD");
                sessionStorage.removeItem("publicationTypes");
                sessionStorage.removeItem("toDate");
                sessionStorage.removeItem("fromDate");
                sessionStorage.removeItem("country");
                sessionStorage.removeItem("freeText");
                sessionStorage.removeItem("publisherTypes");
                sessionStorage.removeItem("topicsAndUnits");
              }}
            />
          )}
          <span
            className={
              location.pathname === REGISTER || location.pathname === LOG_IN
                ? "logo-title fs-14"
                : "display-none"
            }
          >
            {TITLE_BESIDE_LOGO}
          </span>
        </Navbar.Brand>
        {location.pathname !== REGISTER && location.pathname !== LOG_IN ? (
          <Navbar.Toggle
            aria-controls="main-header-nav"
            className="bs-navbar-collapse"
          >
            <img width={25} height={24} src={iconsHamgurger} />
          </Navbar.Toggle>
        ) : (
          <></>
        )}
        {location.pathname !== REGISTER && location.pathname !== LOG_IN ? (
          <Navbar.Collapse id="main-header-nav" className="bs-navbar-collapse">
            <Form inline className="mr-auto search-field-group">
              <InputGroup>
                <FormControl
                  placeholder={t("searchBarMessage")}
                  className={
                    !loggedIn
                      ? "search-field apply-bg-medium-light-shade-cyan-blue-color"
                      : "search-field apply-bg-white-color search-field-logged-in"
                  }
                  xs="5"
                  disabled={!loggedIn}
                  onChange={(e) => setFreeText(e.target.value)}
                  onKeyPress={(e) => {
                    if (
                      (e.charCode === 13 || e.key === "Enter") &&
                      freeText &&
                      loggedIn
                    ) {
                      e.preventDefault();
                      history.push(SEARCH_BY_TEXT_AWAITING_TEXT + freeText);
                    } else if (e.charCode === 13 || e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                />
                <InputGroup.Append>
                  <InputGroup.Text
                    className={
                      !loggedIn
                        ? "search-input-button cursor-not-allowed apply-bg-medium-light-shade-cyan-blue-color fs-16"
                        : "search-input-button cursor-pointer apply-bg-white-color fs-16"
                    }
                  >
                    <img
                      src={iconsSearch}
                      width="25"
                      height="25"
                      className={
                        freeText && loggedIn
                          ? "d-inline-block align-top"
                          : "d-inline-block align-top cursor-not-allowed"
                      }
                      alt="RegHub logo"
                      onClick={() => {
                        if (freeText && loggedIn) {
                          history.push(SEARCH_BY_TEXT_AWAITING_TEXT + freeText);
                        }
                      }}
                    />
                  </InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div
                onClick={() => openManageSourcesDialog()}
                className={
                  loggedIn &&
                  (currentWorkspace.WORKSPACE_TYPE !== WORKSPACE_TYPE_PRIVATE ||
                    userRights.USER_RIGHT === "partner")
                    ? "manage-publication-sources cursor-pointer"
                    : "manage-publication-sources cursor-not-allowed"
                }
              >
                <img width={24} height={24} src={iconsPublications} />
                <span className="manage-publications-label">
                  {t("managePublicationSources")}
                </span>
              </div>
            </Form>
            {!loggedIn ? (
              <Form inline className="header-buttons">
                <Link to={LOG_IN}>
                  <Button
                    as="input"
                    type="button"
                    value={t("logIn")}
                    className="header-button fs-14"
                    variant="cyan-blue"
                  />
                </Link>
                <Link to={REGISTER}>
                  <Button
                    as="input"
                    type="button"
                    value={t("register")}
                    variant="cyan-green"
                    className="header-button fs-14"
                  />
                </Link>
              </Form>
            ) : (
              <Form inline className="header-buttons header-buttons-dropdown">
                <Container className="private-header-workspace-container">
                  {width > 767 || isIPad13 ? (
                    <Dropdown className="private-header-workspace-dropdown">
                      <Dropdown.Toggle id="private-header-workspace-dropdown-toggle">
                        <span className="fs-14">
                          {user.USER_EMAIL.length > 23
                            ? user.USER_EMAIL.substring(0, 19) + "..."
                            : user.USER_EMAIL}
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="header-dropdown" align="right">
                        <Dropdown.Item
                          onClick={() => setIsChangePasswordDialogOpened(true)}
                          className="header-dropdown-item fs-14"
                        >
                          <img
                            width={24}
                            height={24}
                            src={iconsChangePassword}
                            alt={"privateWorkSpaceItemLogo"}
                          />
                          {t("changePassword")}
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item
                          onClick={() =>
                            window.open(
                              "https://app.reghub.io/im-suite/start.ims",
                              "_blank"
                            )
                          }
                          className={
                            currentWorkspace.WORKSPACE_TYPE !==
                            WORKSPACE_TYPE_PRIVATE
                              ? "header-dropdown-item fs-14"
                              : "display-none"
                          }
                        >
                          <img
                            width={24}
                            height={24}
                            src={iconsManage}
                            alt={"privateWorkSpaceItemLogo"}
                          />
                          {t("openRegHubAdmin")}
                        </Dropdown.Item>
                        <Dropdown.Divider
                          className={
                            currentWorkspace.WORKSPACE_TYPE !==
                            WORKSPACE_TYPE_PRIVATE
                              ? ""
                              : "display-none"
                          }
                        />
                        <Dropdown.Item
                          className="header-dropdown-item fs-14"
                          onClick={() => {
                            loggOut();
                            resetParams();
                          }}
                        >
                          <img
                            width={24}
                            height={24}
                            src={iconsLogOut}
                            alt={"privateWorkSpaceItemLogo"}
                          />
                          {t("logOut")}
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item
                          className="header-dropdown-item fs-14"
                          onClick={() => setIsDeletedDialogOpened(true)}
                        >
                          <img
                            width={24}
                            height={24}
                            src={iconsDeleteAccount}
                            alt={"privateWorkSpaceItemLogo"}
                          />
                          {t("deleteAccount")}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <>
                      <span className="header-dropdown-item-toggled fs-14">
                        {user.USER_EMAIL.length > 23
                          ? user.USER_EMAIL.substring(0, 19) + "..."
                          : user.USER_EMAIL}
                      </span>
                      <hr className="header-dropdown-item-toggled-border" />
                      <span
                        onClick={() => setIsChangePasswordDialogOpened(true)}
                        className="header-dropdown-item header-dropdown-item-toggled header-dropdown-sub-item fs-14 cursor-pointer"
                      >
                        <img
                          width={24}
                          height={24}
                          src={iconsChangePassword}
                          alt={"privateWorkSpaceItemLogo"}
                        />
                        {t("changePassword")}
                      </span>
                      <span
                        onClick={() =>
                          window.open(
                            "https://app.reghub.io/im-suite/start.ims",
                            "_blank"
                          )
                        }
                        className={
                          currentWorkspace.WORKSPACE_TYPE !==
                          WORKSPACE_TYPE_PRIVATE
                            ? "header-dropdown-item header-dropdown-item-toggled header-dropdown-sub-item fs-14 cursor-pointer"
                            : "display-none"
                        }
                      >
                        <img
                          width={24}
                          height={24}
                          src={iconsManage}
                          alt={"privateWorkSpaceItemLogo"}
                        />
                        {t("openRegHubAdmin")}
                      </span>
                      <span
                        className="header-dropdown-item header-dropdown-item-toggled header-dropdown-sub-item fs-14 cursor-pointer"
                        onClick={() => loggOut()}
                      >
                        <img
                          width={24}
                          height={24}
                          src={iconsLogOut}
                          alt={"privateWorkSpaceItemLogo"}
                        />
                        {t("logOut")}
                      </span>
                      <span
                        onClick={() => setIsDeletedDialogOpened(true)}
                        className="header-dropdown-item header-dropdown-item-toggled header-dropdown-sub-item fs-14 cursor-pointer"
                      >
                        <img
                          width={24}
                          height={24}
                          src={iconsDeleteAccount}
                          alt={"privateWorkSpaceItemLogo"}
                        />
                        {t("deleteAccount")}
                      </span>
                    </>
                  )}
                </Container>
                <Container className="professional-header-workspace-container">
                  {width > 767 || isIPad13 ? (
                    <Dropdown className="professional-header-workspace-dropdown">
                      <Dropdown.Toggle id="professional-header-workspace-dropdown-toggle">
                        <img
                          width={28}
                          height={28}
                          src={localStorageCurrentWorkspace.WORKSPACE_ICON_PATH}
                          onError={onErrorImg}
                        />
                        <span className="dropdown-title  fs-14">
                          {localStorageCurrentWorkspace.WORKSPACE_NAME}
                        </span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="header-dropdown" align="right">
                        {workspacesOfUser.map((workspace, index) => {
                          return (
                            <React.Fragment
                              key={"professionalWorkspace" + index}
                            >
                              <Dropdown.Item
                                className="header-dropdown-item fs-14"
                                onClick={() => {
                                  workspaceChanged(workspace);
                                  localStorage.removeItem("tiles");
                                  localStorage.removeItem("dataTiles");
                                }}
                              >
                                <img
                                  width={24}
                                  height={24}
                                  src={
                                    workspace.WORKSPACE_ICON_PATH
                                      ? workspace.WORKSPACE_ICON_PATH
                                      : logo
                                  }
                                  onError={onErrorImg}
                                />
                                {workspace.WORKSPACE_NAME}
                                <img
                                  width={24}
                                  height={24}
                                  src={iconsCheckmark}
                                  className={
                                    currentWorkspace.WORKSPACE_NAME ===
                                    workspace.WORKSPACE_NAME
                                      ? "icon-checkmark-header"
                                      : "display-none"
                                  }
                                />
                              </Dropdown.Item>
                              <Dropdown.Divider
                                className={
                                  index === workspacesOfUser.length - 1
                                    ? "display-none"
                                    : ""
                                }
                              />
                            </React.Fragment>
                          );
                        })}
                        <Dropdown.Divider />
                        <Dropdown.Item className="header-dropdown-item fs-14">
                          <Button
                            as="input"
                            type="button"
                            value={t("createATeamWorkspace")}
                            variant="cyan-green"
                            className="header-button create-team-workspace-button dropdown-item-create-team-workspace fs-14"
                            onClick={() =>
                              setIsCreatedATeamWorkspaceDialogOpened(true)
                            }
                          />
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <>
                      {workspacesOfUser.map((workspace, index) => {
                        return (
                          <span
                            key={"toggled-workspace-item" + index}
                            className="header-dropdown-item header-dropdown-item-toggled header-dropdown-sub-item header-workspace-item fs-14 cursor-pointer"
                            onClick={() => workspaceChanged(workspace)}
                          >
                            <img
                              width={24}
                              height={24}
                              src={workspace.WORKSPACE_ICON_PATH}
                              onError={onErrorImg}
                            />
                            {workspace.WORKSPACE_NAME}
                            <img
                              width={24}
                              height={24}
                              src={iconsCheckmark}
                              className={
                                currentWorkspace.WORKSPACE_NAME ===
                                workspace.WORKSPACE_NAME
                                  ? "icon-checkmark-header"
                                  : "display-none"
                              }
                            />
                          </span>
                        );
                      })}
                    </>
                  )}
                  <Button
                    as="input"
                    type="button"
                    value={t("createATeamWorkspace")}
                    variant="cyan-green"
                    className={
                      width > 767 || isIPad13
                        ? "display-none"
                        : "header-button create-team-workspace-button fs-14"
                    }
                    onClick={() => setIsCreatedATeamWorkspaceDialogOpened(true)}
                  />
                </Container>
                {width <= 767 && !isIPad13 ? (
                  <span className="workspace-title fs-14">
                    {t("workspace")}
                  </span>
                ) : (
                  <> </>
                )}
              </Form>
            )}
          </Navbar.Collapse>
        ) : (
          <></>
        )}
      </Navbar>
      <CustomModal
        classNameOfModal="reghub-modal safari-version"
        titleOfModal={t("updateSafariVersion")}
        isShown={isMacOs && isSafari && navigator.sayswho.split(" ")[1] <= 13}
        isBackdrop="static"
        isCentered={true}
        content={
          <>
            <span className="modal-dialog-row-of-text fs-14">
              {t("versionOfSafariNeedsToBe14")}
            </span>
            <br />
            <span className="modal-dialog-row-of-text fs-14">
              {t("thankYouForYourUnderstanding")}
            </span>
          </>
        }
      />
      <CustomModal
        classNameOfModal="reghub-modal"
        titleOfModal={t("deleteAccount")}
        setIsShown={setIsDeletedDialogOpened}
        isShown={isDeletedDialogOpened}
        negativeAction={() => setIsDeletedDialogOpened(false)}
        content={
          <>
            <span className="modal-dialog-row-of-text fs-14">
              {t("youAreAboutToDeleteAccount")}
            </span>
            <br />
            <span className="modal-dialog-row-of-text fs-14">
              {t("areYouSureYouWantToDelete")}
            </span>
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("deleteAccount")}
        positiveAction={() => deleteUserClick()}
        isBackdrop="static"
        isCentered={true}
      />
      <CustomModal
        classNameOfModal="reghub-modal"
        titleOfModal={t("createATeamWorkspace")}
        setIsShown={setIsCreatedATeamWorkspaceDialogOpened}
        isShown={isCreateATeamWorkspaceDialogOpened}
        negativeAction={() => setIsCreatedATeamWorkspaceDialogOpened(false)}
        content={
          <>
            <span className="modal-dialog-row-of-text fs-14">
              {t("thankYouForYourInterestInCreating")}
            </span>
            <br />
            <span className="modal-dialog-row-of-text fs-14">
              {t("byClickingOnCreateTeamWorkspace")}
            </span>
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("createTeamWorkspace")}
        isBackdrop="static"
        positiveAction={() => createTeamWorkSpaceClick()}
        isCentered={true}
      />
      <CustomModal
        classNameOfModal="reghub-modal"
        titleOfModal={t("changePassword")}
        setIsShown={setIsChangePasswordDialogOpened}
        isShown={isChangePasswordDialogOpened}
        negativeAction={() => setIsChangePasswordDialogOpened(false)}
        content={
          <FieldsInForm
            idOfForm="change-password-form"
            fields={argsForFields.fields}
            findFormErrors={argsForFields.findFormErrors}
            classNameForm={argsForFields.classNameForm}
            onSubmit={argsForFields.onSubmit}
            submitOccurred={submitOccurred}
            setSubmitOccurred={setSubmitOccurred}
          />
        }
        negativeButton={t("cancel")}
        positiveButton={t("changePassword")}
        positiveAction={() => setSubmitOccurred(true)}
        typeOfPositiveActionButton="submit"
        isBackdrop="static"
        isCentered={true}
        formId={"change-password-form"}
      />
      <CustomModal
        classNameOfModal="reghub-modal"
        titleOfModal={t("deleteASource")}
        setIsShown={setIsDeleteSourceDialogOpened}
        isShown={isDeleteSourceDialogOpened}
        negativeAction={() => setIsDeleteSourceDialogOpened(false)}
        content={
          <>
            <span className="modal-dialog-row-of-text fs-14">
              {t("youAreAboutToDeleteASource")}
            </span>
            <br />
            <span className="modal-dialog-row-of-text fs-14">
              {t("areYouSureYouWantToDeleteASource")}
            </span>
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("delete")}
        positiveAction={() => {
          deleteCrawlerSource(userToken, selectedSourceId);
          setIsDeleteSourceDialogOpened(false);
        }}
        isBackdrop="static"
        isCentered={true}
      />
      <CustomModal
        classNameOfModal="reghub-modal manage-sources-modal"
        titleOfModal={t("managePublicationSources")}
        setIsShown={setShowManageSourcesDialog}
        isShown={showManageSourcesDialog}
        negativeAction={() => setShowManageSourcesDialog(false)}
        negativeButton={t("cancel")}
        isBackdrop="static"
        isCentered={true}
        content={
          <>
            {sourcesAreLoading ? (
              <Loader />
            ) : (
              <div className="manage-sources-content-container">
                <span
                  className="add-manage-source-span cursor-pointer"
                  onClick={() => setIsAddPublicationSourceOpened(true)}
                >
                  <img
                    src={iconsAddToList}
                    className="add-manage-source-img"
                    width={24}
                    height={24}
                  />
                  <span className="add-manage-source-span-lbl">
                    {t("addPublicationSource")}
                  </span>
                </span>
                <div className="ag-theme-alpine manage-sources-grid">
                  <AgGridReact
                    rowData={sources}
                    rowSelection="none"
                    loadingOverlayComponent={<Loader />}
                    headerHeight={55}
                    pattern="None"
                    frameworkComponents={{ functionsOfGrid: functionsOfGrid }}
                  >
                    <AgGridColumn
                      field="NAME"
                      headerName={t("name")}
                      flex={2}
                      sortable
                      filter
                      wrapText
                      autoHeight
                      resizable
                    />
                    <AgGridColumn
                      field="URL"
                      headerName={t("url")}
                      cellClass="overview-grid-cell"
                      sortable
                      filter
                      flex={3}
                      resizable
                    />
                    <AgGridColumn
                      field="COUNTRY"
                      headerName={t("country")}
                      cellClass="overview-grid-cell"
                      sortable
                      filter
                      flex={1}
                      resizable
                    />
                    <AgGridColumn
                      field="CREATED_BY"
                      headerName={t("addedBy")}
                      cellClass="overview-grid-cell"
                      sortable
                      filter
                      flex={1}
                      resizable
                    />

                    <AgGridColumn
                      field="FORMAT"
                      headerName={t("format")}
                      cellClass="overview-grid-cell"
                      sortable
                      filter
                      flex={1}
                      resizable
                    />
                    <AgGridColumn
                      cellClass="overview-grid-cell"
                      cellRenderer="functionsOfGrid"
                      flex={1}
                      resizable
                    />
                  </AgGridReact>
                </div>
              </div>
            )}
          </>
        }
      />
      <CustomModal
        classNameOfModal="reghub-modal add-publication-source-modal"
        titleOfModal={t("addPublicationSource")}
        setIsShown={setIsAddPublicationSourceOpened}
        isShown={isAddPublicationSourceOpened}
        negativeAction={() => setIsAddPublicationSourceOpened(false)}
        content={
          <>
            <span
              className="label-for-back cursor-pointer"
              onClick={() => setIsAddPublicationSourceOpened(false)}
            >
              <img
                height={24}
                width={24}
                src={iconsBack}
                className="add-publication-source-icon"
              />
              <label>{t("back")}</label>
            </span>
            <FieldsInForm
              idOfForm="add-publication-source-form"
              fields={argsForAddEditPublicationSourceDialog.fields}
              findFormErrors={
                argsForAddEditPublicationSourceDialog.findFormErrors
              }
              classNameForm={
                argsForAddEditPublicationSourceDialog.classNameForm
              }
              onSubmit={argsForAddEditPublicationSourceDialog.onSubmit}
              submitOccurred={submitSourceOccurred}
              setSubmitOccurred={setSubmitSourceOccurred}
            />
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("preview")}
        positiveAction={() => setSubmitSourceOccurred(true)}
        typeOfPositiveActionButton="submit"
        isBackdrop="static"
        isCentered={true}
        formId={"add-publication-source-form"}
      />
      <CustomModal
        classNameOfModal="reghub-modal add-publication-source-modal"
        titleOfModal={t("editPublicationSource")}
        setIsShown={setIsEditPublicationSourceOpened}
        isShown={isEditPublicationSourceOpened}
        negativeAction={() => setIsEditPublicationSourceOpened(false)}
        content={
          <>
            <span
              className="label-for-back cursor-pointer"
              onClick={() => setIsEditPublicationSourceOpened(false)}
            >
              <img
                height={24}
                width={24}
                src={iconsBack}
                className="add-publication-source-icon"
              />
              <label>{t("back")}</label>
            </span>
            <FieldsInForm
              idOfForm="edit-publication-source-form"
              fields={argsForAddEditPublicationSourceDialog.fields}
              findFormErrors={
                argsForAddEditPublicationSourceDialog.findFormErrors
              }
              classNameForm={
                argsForAddEditPublicationSourceDialog.classNameForm
              }
              onSubmit={argsForAddEditPublicationSourceDialog.onSubmit}
              existingData={selectedSourceRecord}
              submitOccurred={submitSourceOccurred}
              setSubmitOccurred={setSubmitSourceOccurred}
            />
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("preview")}
        positiveAction={() => setSubmitSourceOccurred(true)}
        typeOfPositiveActionButton="submit"
        isBackdrop="static"
        isCentered={true}
        formId={"edit-publication-source-form"}
      />
      <CustomModal
        classNameOfModal="reghub-modal add-publication-source-modal preview-publication-source-modal"
        titleOfModal={t("previewResults")}
        setIsShown={setPreviewForAdditionOccured}
        isShown={previewForAdditionOccurred}
        negativeAction={() => setPreviewForAdditionOccured(false)}
        content={
          <>
            <span
              className="label-for-back cursor-pointer"
              onClick={() => setPreviewForAdditionOccured(false)}
            >
              <img
                height={24}
                width={24}
                src={iconsBack}
                className="add-publication-source-icon"
              />
              <label>{t("back")}</label>
            </span>
            <span className="preview-results-note">
              <span className="preview-note">{t("note") + ": "}</span>
              <span className="preview-note-message">
                {t("itMightTakeTo7daysPreview")}
              </span>
            </span>
            <Row className="preview-source-first-great-row">
              <Row className="preview-source-first-sub-row">
                <Col className="preview-source-col">
                  <span className="preview-group">
                    <span className="preview-group-title">{t("name")}</span>
                    <span className="preview-group-info">
                      {previewedCrawlerSource.data
                        ? previewedCrawlerSource.data.RegHub_response["NAME"]
                        : ""}
                    </span>
                  </span>
                </Col>
                <Col className="preview-source-col">
                  <span className="preview-group">
                    <span className="preview-group-title">
                      {t("publisherType")}
                    </span>
                    <span className="preview-group-info">
                      {previewedCrawlerSource.data
                        ? previewedCrawlerSource.data.RegHub_response[
                            "PUBLISHER_TYPE"
                          ]
                        : ""}
                    </span>
                  </span>
                </Col>
                <Col className="preview-source-col">
                  <span className="preview-group">
                    <span className="preview-group-title">{t("country")}</span>
                    <span className="preview-group-info">
                      {previewedCrawlerSource.data
                        ? previewedCrawlerSource.data.RegHub_response["COUNTRY"]
                        : ""}
                    </span>
                  </span>
                </Col>
              </Row>
              <Row className="preview-source-second-sub-row">
                <Col className="preview-source-col">
                  <span className="preview-group">
                    <span className="preview-group-title">{t("url")}</span>
                    <span className="preview-group-info">
                      {previewedCrawlerSource.data
                        ? previewedCrawlerSource.data.RegHub_response["URL"]
                        : ""}
                    </span>
                  </span>
                </Col>
                <Col className="preview-source-col"></Col>
                <Col className="preview-source-col">
                  <span className="preview-group">
                    <span className="preview-group-title">{t("format")}</span>
                    <span className="preview-group-info">
                      {previewedCrawlerSource.data
                        ? previewedCrawlerSource.data.RegHub_response["FORMAT"]
                        : ""}
                    </span>
                  </span>
                </Col>
              </Row>
            </Row>
            <hr className="preview-hr-manage-source" />
            <Row className="preview-source-second-great-row">
              <Row className="preview-source-third-sub-row">
                <span className="preview-group">
                  <span className="preview-group-title">
                    {t("numberOfFoundPublications")}
                  </span>
                  <span className="preview-group-info">
                    {previewedCrawlerSource.data
                      ? previewedCrawlerSource.data.RegHub_response[
                          "NUMBER_FOUND_PUBLICATIONS"
                        ]
                      : ""}
                  </span>
                </span>
              </Row>
              <Row className="preview-source-fourth-sub-row">
                <span className="preview-group">
                  <span className="preview-group-title">
                    {t("foundTopics")}
                  </span>
                  <span className="preview-group-info">
                    {previewedCrawlerSource.data
                      ? previewedCrawlerSource.data.RegHub_response[
                          "FOUND_TOPICS"
                        ]
                      : ""}
                  </span>
                </span>
              </Row>
              <Row className="preview-source-fifth-sub-row">
                <span className="preview-group">
                  <span className="preview-group-title">
                    {t("proportionOfPublicationsWithAFoundTopic")}
                  </span>
                  <span className="preview-group-info">
                    {previewedCrawlerSource.data
                      ? previewedCrawlerSource.data.RegHub_response[
                          "PUBLICATION_RATIO"
                        ]
                      : ""}
                  </span>
                  <span className="preview-group-sub-info display-none">
                    <span className="preview-group-sub-info-item">
                      {t("explanationOfPercentages") + ":"}
                    </span>
                    <span className="preview-group-sub-info-item">
                      {t("lessThanOrEqualTo30PercentLowQuality")}
                    </span>
                  </span>
                </span>
              </Row>
              <Row className="preview-source-sixth-sub-row">
                <span className="preview-group">
                  <span className="preview-group-title">{t("summary")}</span>
                  <span className="preview-group-info">
                    {previewedCrawlerSource.data
                      ? previewedCrawlerSource.data.RegHub_response["SUMMARY"]
                      : ""}
                  </span>
                </span>
              </Row>
              <Row
                className={
                  previewedCrawlerSource.status === 400 ||
                  previewedCrawlerSource.status === 401
                    ? "preview-source-sixth-sub-row"
                    : "display-none"
                }
              >
                <span className="preview-group">
                  <span className="preview-group-title">
                    {t("responseMessage")}
                  </span>
                  <span className="preview-group-info">
                    {previewedCrawlerSource.data &&
                    (previewedCrawlerSource.status === 400 ||
                      previewedCrawlerSource.status === 401) &&
                    previewCrawlerSources.data.RegHub_response === undefined
                      ? previewedCrawlerSource.data
                      : ""}
                  </span>
                </span>
              </Row>
            </Row>
          </>
        }
        negativeButton={t("cancel")}
        positiveButton={t("save")}
        positiveAction={() => saveSource()}
        isPositiveButtonDisabled={previewedCrawlerSource.status !== 200}
        typeOfPositiveActionButton="submit"
        isBackdrop="static"
        isCentered={true}
        formId={"change-password-form"}
      />
      {isDeleted ? (
        <AlertMessage
          variant="success"
          onClose={() => setIsDeleted(false)}
          successHeading={t("success")}
          mainMessage={t("successfullyDeletedAnAccount")}
        />
      ) : (
        <div className="display-none" />
      )}
      {isChangedPassword ? (
        <AlertMessage
          variant="success"
          onClose={() => setIsChangedPassword(false)}
          successHeading={t("success")}
          mainMessage={t("successfullyChangedAPassword")}
        />
      ) : (
        <div className="display-none" />
      )}
      {isCreatedTeamWorkspace ? (
        <AlertMessage
          variant="success"
          onClose={() => setIsCreatedATeamWorkspace(false)}
          successHeading={t("success")}
          mainMessage={t("youWillBeContactedByOurSupportAgents")}
        />
      ) : (
        <div className="display-none" />
      )}
      {sourcesErrorMessageOn ? (
        <AlertMessage
          variant="danger"
          onClose={() => setIsSourcesErrorMessageOn(false)}
          successHeading={t("failure")}
          mainMessage={sourcesErrorMessageLocal}
        />
      ) : (
        <div className="display-none" />
      )}
      {sourcesSuccessMessageOn ? (
        <AlertMessage
          variant="success"
          onClose={() => setIsSourcesSuccessMessageOn(false)}
          successHeading={t("success")}
          mainMessage={sourcesSuccessMessageLocal}
        />
      ) : (
        <div className="display-none" />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loggedIn: state.userReducer.loggedIn,
    user: state.userReducer.user,
    workspacesOfUser: state.userReducer.workspacesOfUser,
    userRegistrationIsLoading: state.userReducer.userRegistrationIsLoading,
    userLoggingIsLoading: state.userReducer.userLoggingIsLoading,
    sourcesSuccessMessage: state.sourcesReducer.sourcesSuccessMessage,
    sourcesAreLoadedWithErrorMessage:
      state.sourcesReducer.sourcesAreLoadedWithErrorMessage,
    userRights: state.userReducer.userRights,
    userToken: state.configReducer.userToken,
    sourcesAreLoading: state.sourcesReducer.sourcesAreLoading,
    sources: state.sourcesReducer.sources,
    filtersTypes: state.filterReducer.filtersTypes,
    previewedCrawlerSource: state.sourcesReducer.previewedCrawlerSource,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loggedOut: bindActionCreators(loggedOut, dispatch),
    getInitialUserToken: bindActionCreators(getInitialUserToken, dispatch),
    changeUserTokenAndCurrentWorkspace: bindActionCreators(
      changeUserTokenAndCurrentWorkspace,
      dispatch
    ),
    restartTopicMessages: bindActionCreators(restartTopicMessages, dispatch),
    checkUserRights: bindActionCreators(checkUserRights, dispatch),
    crawlerSourcesAreLoadedWithErrorAction: bindActionCreators(
      crawlerSourcesAreLoadedWithErrorAction,
      dispatch
    ),
    crawlerSourcesSuccessMessageFired: bindActionCreators(
      crawlerSourcesSuccessMessageFired,
      dispatch
    ),
    getCrawlerSources: bindActionCreators(getCrawlerSources, dispatch),
    deleteCrawlerSource: bindActionCreators(deleteCrawlerSource, dispatch),
    getFilterTypes: bindActionCreators(getFilterTypes, dispatch),
    previewCrawlerSources: bindActionCreators(previewCrawlerSources, dispatch),
    addCrawlerSources: bindActionCreators(addCrawlerSources, dispatch),
    updateCrawlerSources: bindActionCreators(updateCrawlerSources, dispatch),
  };
};

Header.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    USER_EMAIL: PropTypes.string,
    USER_TOKEN: PropTypes.string,
  }).isRequired,
  workspacesOfUser: PropTypes.arrayOf(
    PropTypes.shape({
      PREFFERRED: PropTypes.string,
      USER_TOKEN: PropTypes.string,
      WORKSPACE_ICON_PATH: PropTypes.string,
      WORKSPACE_NAME: PropTypes.string,
      WORKSPACE_TYPE: PropTypes.string,
    })
  ),
  loggedOut: PropTypes.func.isRequired,
  getInitialUserToken: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  changeUserTokenAndCurrentWorkspace: PropTypes.func.isRequired,
  restartTopicMessages: PropTypes.func.isRequired,
  checkUserRights: PropTypes.func.isRequired,
  userRegistrationIsLoading: PropTypes.bool.isRequired,
  userLoggingIsLoading: PropTypes.bool.isRequired,
  sourcesSuccessMessage: PropTypes.string.isRequired,
  sourcesAreLoadedWithErrorMessage: PropTypes.string.isRequired,
  crawlerSourcesAreLoadedWithErrorAction: PropTypes.func.isRequired,
  crawlerSourcesSuccessMessageFired: PropTypes.func.isRequired,
  userRights: PropTypes.shape({
    USER_RIGHT: PropTypes.string,
  }).isRequired,
  getCrawlerSources: PropTypes.func.isRequired,
  userToken: PropTypes.string.isRequired,
  sourcesAreLoading: PropTypes.bool.isRequired,
  sources: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  deleteCrawlerSource: PropTypes.func.isRequired,
  filtersTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  getFilterTypes: PropTypes.func.isRequired,
  previewCrawlerSources: PropTypes.func.isRequired,
  previewedCrawlerSource: PropTypes.shape({
    data: PropTypes.shape({
      RegHub_response: PropTypes.shape({
        COUNTRY: PropTypes.string,
        FORMAT: PropTypes.string,
        FOUND_TOPICS: PropTypes.string,
        NAME: PropTypes.string,
        NUMBER_FOUND_PUBLICATIONS: PropTypes.number,
        NUMBER_FOUND_PUBLICATIONS_WITH_TOPICS: PropTypes.number,
        PUBLICATION_RATIO: PropTypes.string,
        PUBLISHER_TYPE: PropTypes.string,
        SUMMARY: PropTypes.string,
        URL: PropTypes.string,
      }),
    }),
    status: PropTypes.number,
  }).isRequired,
  addCrawlerSources: PropTypes.func.isRequired,
  updateCrawlerSources: PropTypes.func.isRequired,
};

Header.defaultProps = {
  loggedIn: false,
  user: {},
  workspacesOfUser: [],
  loggedOut: () => {},
  getInitialUserToken: () => {},
  dispatch: () => {},
  changeUserTokenAndCurrentWorkspace: () => {},
  restartTopicMessages: () => {},
  checkUserRights: () => {},
  userRegistrationIsLoading: false,
  userLoggingIsLoading: false,
  sourcesSuccessMessage: "",
  sourcesAreLoadedWithErrorMessage: "",
  crawlerSourcesAreLoadedWithErrorAction: () => {},
  crawlerSourcesSuccessMessageFired: () => {},
  userRights: { USER_RIGHT: "" },
  getCrawlerSources: () => {},
  userToken: "",
  sourcesAreLoading: false,
  sources: [],
  deleteCrawlerSource: () => {},
  filtersTypes: [],
  getFilterTypes: () => {},
  previewCrawlerSources: () => {},
  previewedCrawlerSource: PropTypes.shape({
    COUNTRY: "",
    FORMAT: "",
    FOUND_TOPICS: "",
    NAME: "",
    NUMBER_FOUND_PUBLICATIONS: 0,
    NUMBER_FOUND_PUBLICATIONS_WITH_TOPICS: 0,
    PUBLICATION_RATIO: "",
    PUBLISHER_TYPE: "",
    SUMMARY: "",
    URL: "",
  }).isRequired,
  addCrawlerSources: () => {},
  updateCrawlerSources: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
